import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { CONTACT } from '../../config';

const TEXTS = {
  es: {
    phoneTitle: 'Atención telefónica',
    emailTitle: 'Por correo, también fuera de horario',
  },
  en: {
    phoneTitle: 'Phone support',
    emailTitle: 'By email, also outside business hours',
  },
};

/**
 * Teléfono, horario y email de contacto. Se usa en la página de contacto, en
 * sus tres vías (demo, formulario, llamada) y en el pie.
 *
 * `compact` pinta una sola línea (para los pies de página de formularios).
 */
const ContactChannels = ({ lang = 'es', compact = false, className = '' }) => {
  const t = TEXTS[lang] || TEXTS.es;
  const hours = CONTACT.phoneHours[lang] || CONTACT.phoneHours.es;

  if (compact) {
    return (
      <p className={`text-center text-sm text-gray-500 ${className}`}>
        <Phone className="inline w-4 h-4 mr-1 -mt-0.5" />
        <a href={CONTACT.phoneHref} className="text-blue-600 hover:underline">{CONTACT.phoneDisplay}</a>
        {' '}· {hours} ·{' '}
        <a href={`mailto:${CONTACT.email}`} className="text-blue-600 hover:underline">{CONTACT.email}</a>
      </p>
    );
  }

  return (
    <div className={`grid sm:grid-cols-2 gap-x-10 gap-y-8 ${className}`}>
      <div className="flex items-start gap-4">
        <Phone className="w-6 h-6 mt-0.5 flex-shrink-0 text-primary-700" strokeWidth={1.5} />
        <div>
          <h3 className="text-sm font-semibold text-slate-500 mb-1">{t.phoneTitle}</h3>
          <a href={CONTACT.phoneHref} className="text-xl font-semibold text-slate-900 hover:text-primary-700">
            {CONTACT.phoneDisplay}
          </a>
          <p className="mt-1 text-sm text-slate-500">{hours}</p>
        </div>
      </div>
      <div className="flex items-start gap-4">
        <Mail className="w-6 h-6 mt-0.5 flex-shrink-0 text-primary-700" strokeWidth={1.5} />
        <div>
          <h3 className="text-sm font-semibold text-slate-500 mb-1">{t.emailTitle}</h3>
          <a href={`mailto:${CONTACT.email}`} className="text-xl font-semibold text-slate-900 hover:text-primary-700">
            {CONTACT.email}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactChannels;
